import { ElementRef, NgZone, TemplateRef } from '@angular/core';
import { HttpResponse } from "@angular/common/http";
import { SessionService } from '../../../session/session.service';
import { MessageService } from '../../../message/message.service';
import { SRQCompletedService } from '../../../srq-completed/srq-completed.service';
import { QuestionarreAnswerService } from '../../../questionarre-answer/questionarre-answer.service';
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStorageService } from "ngx-webstorage";
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { VideoCallService } from '../../../video-call/video-call.service';
import { ZoomService } from '../../../video-call/zoom.service';
import { AccountService } from '../../../../core/auth/account.service';
import { BaseComponent } from '../../../../shared/base.component';
import { JhiAlertService, JhiEventManager } from '../../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../../session/session.service";
import * as i2 from "../../../message/message.service";
import * as i3 from "../../../srq-completed/srq-completed.service";
import * as i4 from "../../../questionarre-answer/questionarre-answer.service";
import * as i5 from "@angular/router";
import * as i6 from "ngx-webstorage";
import * as i7 from "../../../../core/tracker/tracker.service";
import * as i8 from "@ng-bootstrap/ng-bootstrap";
import * as i9 from "../../../../ng-jhipster/service";
import * as i10 from "@ngx-translate/core";
import * as i11 from "../../../video-call/video-call.service";
import * as i12 from "../../../video-call/zoom.service";
import * as i13 from "../../../../core/auth/account.service";
import * as i14 from "@angular/common";
import * as i15 from "../../../video-call/join-video-call/join-video-call.component";
import * as i16 from "../../../video-call/coach-session-control/coach-session-control.component";
import * as i17 from "../../../video-call/coach-session-control/coach-session-control-upper-mobile.component";
import * as i18 from "@fortawesome/angular-fontawesome";
import * as i19 from "../scripts/scripts.component";
import * as i20 from "../../../video-call/zoom-call/zoom-call.component";
import * as i21 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i22 from "../../chat-ui/message-send/session-message-send.component";
import * as i23 from "../../../video-call/coach-session-control/coach-session-control-lower-mobile.component";
import * as i24 from "../../../../shared/user-info/user-info.component";
import * as i25 from "../inuka-journey-coach-chat/inuka-journey-coach-chat.component";
import * as i26 from "../../chat-ui-new/chat-ui-new.component";
import * as i27 from "../edit-action-plan/edit-action-plan.component";
import * as i28 from "@angular/material/tooltip";
import * as i29 from "../coach-user-note/coach-user-note.component";
import * as i30 from "../previous-session-transcript-popup/previous-session-transcript-popup.component";
const _c0 = ["previousSessionTranscriptModal"];
function VideoSessionCoachComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "join-video-call", 7);
    i0.ɵɵlistener("onJoinCallClick", function VideoSessionCoachComponent_div_0_ng_container_3_Template_join_video_call_onJoinCallClick_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.joinVideoCall(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("session", ctx_r4.session);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_user_info_21_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "user-info", 61);
    i0.ɵɵlistener("onCloseIconClick", function VideoSessionCoachComponent_div_0_ng_container_4_user_info_21_Template_user_info_onCloseIconClick_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(3); return ctx_r27.toggleRightSidebar(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("session", ctx_r12.session)("user", ctx_r12.session.user)("srqHistory", ctx_r12.srqHistory)("showCloseIcon", true);
} }
function VideoSessionCoachComponent_div_0_ng_container_4__svg_use_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 62);
} }
function VideoSessionCoachComponent_div_0_ng_container_4__svg_use_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 63);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵelementStart(2, "div", 66);
    i0.ɵɵelementStart(3, "div", 67);
    i0.ɵɵelementStart(4, "inuka-journey-coach-chat", 68);
    i0.ɵɵlistener("sessionSelectedToOpenInThisTab", function VideoSessionCoachComponent_div_0_ng_container_4_div_32_Template_inuka_journey_coach_chat_sessionSelectedToOpenInThisTab_4_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(3); return ctx_r29.showPreviousSessionTranscriptInThisTab($event); })("sessionSelectedToOpenInNewTab", function VideoSessionCoachComponent_div_0_ng_container_4_div_32_Template_inuka_journey_coach_chat_sessionSelectedToOpenInNewTab_4_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(3); return ctx_r31.showPreviousSessionTranscriptInNewTab($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("sessions", ctx_r15.userAllSessions)("srqHistory", ctx_r15.srqHistory);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_45_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "chat-ui-new", 69);
    i0.ɵɵlistener("unreadMessageCountChange", function VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_45_Template_chat_ui_new_unreadMessageCountChange_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(3); return ctx_r32.updateUnreadMessageCount($event); })("repliedMessage", function VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_45_Template_chat_ui_new_repliedMessage_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.repliedMessage($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("viewportHeight", "100%")("session", ctx_r17.session)("displayingPastSession", false);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "chat-ui-new", 70);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("viewportHeight", "100%")("session", ctx_r20.session)("displayingPastSession", false);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_button_55_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 71);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_button_55_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(3); return ctx_r35.turnOffTranscription(); });
    i0.ɵɵtext(1, "TurnOff Transcription");
    i0.ɵɵelementEnd();
} }
function VideoSessionCoachComponent_div_0_ng_container_4_button_56_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 72);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_button_56_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return ctx_r37.turnOnTranscription(); });
    i0.ɵɵtext(1, "TurnOn Transcription");
    i0.ɵɵelementEnd();
} }
function VideoSessionCoachComponent_div_0_ng_container_4_div_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelementStart(1, "div", 74);
    i0.ɵɵelementStart(2, "div", 75);
    i0.ɵɵelement(3, "edit-action-plan", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r24.session)("disabled", !ctx_r24.session.started);
} }
function VideoSessionCoachComponent_div_0_ng_container_4_div_58_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵelementStart(2, "div", 77);
    i0.ɵɵelementStart(3, "div", 78);
    i0.ɵɵelementStart(4, "div", 79);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_div_58_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(3); return ctx_r39.goToLink("/#/notes/" + ctx_r39.session.user.id + "/" + ctx_r39.session.coachId); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 80);
    i0.ɵɵelement(7, "use", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(8, "coach-user-note", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(5, 6, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isEmbedded", true)("userId", ctx_r25.session == null ? null : ctx_r25.session.user.id)("coachId", ctx_r25.coach.id);
} }
const _c1 = function (a0) { return { "max-height": a0 }; };
const _c2 = function (a0) { return { "d-none d-lg-flex": a0 }; };
const _c3 = function (a0, a1) { return { "max-width": a0, "max-height": a1 }; };
const _c4 = function (a0) { return { "bg-success viewModeButtonActive": a0 }; };
const _c5 = function (a0) { return { height: a0 }; };
function VideoSessionCoachComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", null, 8);
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelementStart(4, "coach-session-control", 10);
    i0.ɵɵlistener("displayScriptComponent", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_displayScriptComponent_4_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.toggleScriptSelector(); })("displayUserPanel", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_displayUserPanel_4_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.toggleRightSidebar(); })("onStopCall", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_onStopCall_4_listener() { i0.ɵɵrestoreView(_r42); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.endVideoCall(); })("resourceSelected", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_resourceSelected_4_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelementStart(6, "coach-session-control-upper-mobile", 12);
    i0.ɵɵlistener("displayScriptComponent", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_upper_mobile_displayScriptComponent_6_listener() { i0.ɵɵrestoreView(_r42); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.toggleScriptSelector(); })("displayUserPanel", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_upper_mobile_displayUserPanel_6_listener() { i0.ɵɵrestoreView(_r42); const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.toggleRightSidebar(); })("resourceSelected", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_upper_mobile_resourceSelected_6_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 13, 14);
    i0.ɵɵelementStart(9, "div", 15);
    i0.ɵɵelementStart(10, "div", 16);
    i0.ɵɵelementStart(11, "fa-icon", 17);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_fa_icon_click_11_listener() { i0.ɵɵrestoreView(_r42); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.toggleScriptSelector(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 18);
    i0.ɵɵelementStart(13, "scripts-component", 19);
    i0.ɵɵlistener("messageSelected", function VideoSessionCoachComponent_div_0_ng_container_4_Template_scripts_component_messageSelected_13_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.onScriptSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 20, 21);
    i0.ɵɵelement(16, "zoom-call", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 23, 24);
    i0.ɵɵelementStart(19, "div", 25);
    i0.ɵɵelementStart(20, "div", 26);
    i0.ɵɵtemplate(21, VideoSessionCoachComponent_div_0_ng_container_4_user_info_21_Template, 1, 4, "user-info", 27);
    i0.ɵɵelement(22, "hr", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 29);
    i0.ɵɵelementStart(24, "div", 30);
    i0.ɵɵelementStart(25, "a", 31);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_a_click_25_listener() { i0.ɵɵrestoreView(_r42); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.toggleUserJourney(); });
    i0.ɵɵtext(26, "Journey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 32);
    i0.ɵɵelementStart(28, "a", 33);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r42); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.toggleUserJourney(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(29, "svg", 34);
    i0.ɵɵtemplate(30, VideoSessionCoachComponent_div_0_ng_container_4__svg_use_30_Template, 1, 0, "use", 35);
    i0.ɵɵtemplate(31, VideoSessionCoachComponent_div_0_ng_container_4__svg_use_31_Template, 1, 0, "use", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, VideoSessionCoachComponent_div_0_ng_container_4_div_32_Template, 5, 2, "div", 37);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(33, "div", 38);
    i0.ɵɵelementStart(34, "div", 39);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_div_click_34_listener() { i0.ɵɵrestoreView(_r42); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.switchViewMode("Chat"); });
    i0.ɵɵelement(35, "h4", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 41);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_div_click_36_listener() { i0.ɵɵrestoreView(_r42); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.switchViewMode("Transcript"); });
    i0.ɵɵelement(37, "h4", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 41);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_div_click_38_listener() { i0.ɵɵrestoreView(_r42); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.switchViewMode("ActionPlan"); });
    i0.ɵɵelement(39, "h4", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 41);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_div_0_ng_container_4_Template_div_click_40_listener() { i0.ɵɵrestoreView(_r42); const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.switchViewMode("Notes"); });
    i0.ɵɵelement(41, "h4", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 45, 46);
    i0.ɵɵelementStart(44, "div", 47);
    i0.ɵɵtemplate(45, VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_45_Template, 1, 3, "chat-ui-new", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", null, 49);
    i0.ɵɵelement(48, "session-message-send", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 45, 51);
    i0.ɵɵelementStart(51, "div", 47);
    i0.ɵɵtemplate(52, VideoSessionCoachComponent_div_0_ng_container_4_chat_ui_new_52_Template, 1, 3, "chat-ui-new", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 53, 54);
    i0.ɵɵtemplate(55, VideoSessionCoachComponent_div_0_ng_container_4_button_55_Template, 2, 0, "button", 55);
    i0.ɵɵtemplate(56, VideoSessionCoachComponent_div_0_ng_container_4_button_56_Template, 2, 0, "button", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, VideoSessionCoachComponent_div_0_ng_container_4_div_57_Template, 4, 2, "div", 57);
    i0.ɵɵtemplate(58, VideoSessionCoachComponent_div_0_ng_container_4_div_58_Template, 9, 8, "div", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 58, 59);
    i0.ɵɵelementStart(61, "coach-session-control-lower-mobile", 60);
    i0.ɵɵlistener("onStopCall", function VideoSessionCoachComponent_div_0_ng_container_4_Template_coach_session_control_lower_mobile_onStopCall_61_listener() { i0.ɵɵrestoreView(_r42); const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.endVideoCall(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(2);
    const _r9 = i0.ɵɵreference(8);
    const _r10 = i0.ɵɵreference(15);
    const _r16 = i0.ɵɵreference(43);
    const _r18 = i0.ɵɵreference(47);
    const _r19 = i0.ɵɵreference(50);
    const _r21 = i0.ɵɵreference(54);
    const _r26 = i0.ɵɵreference(60);
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(2);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("session", ctx_r5.session)("isUserPanelOn", ctx_r5.showRightSidebar)("showUnreadIndicator", ctx_r5.showUnreadIndicator)("isScriptOn", ctx_r5.showScriptSelector);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("session", ctx_r5.session)("showUnreadIndicator", ctx_r5.showUnreadIndicator)("isUserPanelOn", ctx_r5.showRightSidebar)("isScriptOn", ctx_r5.showScriptSelector);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(41, _c1, _r3.offsetHeight - (_r8.offsetHeight + _r26.offsetHeight + 60) + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.showScriptSelector ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(43, _c2, ctx_r5.showRightSidebar))("ngStyle", i0.ɵɵpureFunction2(45, _c3, ctx_r5.showRightSidebar ? ctx_r5.windowWidth * 0.75 + "px" : "unset", _r9.offsetHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("session", ctx_r5.session)("height", _r10.offsetHeight)("participantUser", ctx_r5.session.user)("selfUser", ctx_r5.session.coach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r5.showRightSidebar ? "d-flex flex-column" : "d-none")("ngStyle", i0.ɵɵpureFunction1(48, _c1, _r9.offsetHeight + "px"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.session == null ? null : ctx_r5.session.user);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r5.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showUserJourney);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showUserJourney && ctx_r5.userAllSessions && ctx_r5.srqHistory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(50, _c4, ctx_r5.viewMode === "Chat"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(52, _c4, ctx_r5.viewMode === "Transcript"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(54, _c4, ctx_r5.viewMode === "ActionPlan"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(56, _c4, ctx_r5.viewMode === "Notes"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.viewMode === "Chat" && !ctx_r5.showUserJourney ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(58, _c5, _r16.offsetHeight - _r18.offsetHeight - 50 + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r5.session)("message", ctx_r5.message)("maxCharacterSize", 3000)("messageToBeReplied", ctx_r5.messageToBeReplied);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r5.viewMode === "Transcript" && !ctx_r5.showUserJourney ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(60, _c5, _r19.offsetHeight - _r21.offsetHeight - 50 + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r5.isTranscriptionEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isTranscriptionEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.viewMode == "ActionPlan" && ctx_r5.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.viewMode == "Notes" && ctx_r5.session);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("session", ctx_r5.session);
} }
function VideoSessionCoachComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3, 4);
    i0.ɵɵtemplate(3, VideoSessionCoachComponent_div_0_ng_container_3_Template, 3, 1, "ng-container", 5);
    i0.ɵɵtemplate(4, VideoSessionCoachComponent_div_0_ng_container_4_Template, 62, 62, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.view === "PREVIEW");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.view === "JOINED");
} }
function VideoSessionCoachComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "fa-icon", 17);
    i0.ɵɵlistener("click", function VideoSessionCoachComponent_ng_template_1_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r60); const modal_r58 = restoredCtx.$implicit; return modal_r58.dismiss("Cross click"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 83);
    i0.ɵɵelement(4, "previous-session-transcript-popup", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("showInModal", true)("session", ctx_r2.previousSessionToShowTranscript);
} }
export class VideoSessionCoachComponent extends BaseComponent {
    constructor(sessionService, messageService, srqCompletedService, questionarreAnswerService, route, sessionStorage, trackerService, modalService, alertService, translate, ngZone, elementRef, eventManager, router, videoCallService, zoomService, accountService) {
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.srqCompletedService = srqCompletedService;
        this.questionarreAnswerService = questionarreAnswerService;
        this.route = route;
        this.sessionStorage = sessionStorage;
        this.trackerService = trackerService;
        this.modalService = modalService;
        this.alertService = alertService;
        this.translate = translate;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.eventManager = eventManager;
        this.router = router;
        this.videoCallService = videoCallService;
        this.zoomService = zoomService;
        this.accountService = accountService;
        this.view = 'PREVIEW';
        this.showUserJourney = false;
        this.viewMode = 'Chat';
        this.showRightSidebar = true;
        this.message = '';
    }
    ngOnInit() {
        const sessionIdFromUrl = this.route.snapshot.params["sessionId"];
        // get current session and coach data
        // get past messages
        this.messageService.getSession(sessionIdFromUrl).subscribe((res1) => {
            this.onSuccess(res1.body);
        }, err => this.onError(err));
        this.organizationResourceSubscription = this.eventManager.subscribe('organizationResourceSelected', (response) => {
            console.log(response);
            this.message = response.content;
        });
        this.subscribeToWebsocket();
    }
    subscribeToWebsocket() {
        this.websocketSubscription = this.trackerService.listenerSubject.subscribe(value => {
            const message = value['body'];
            const type = value['type'];
            if (type === 'SESSION_STATUS_CHANGED') {
                let s = message;
                // console.log('SESSION_STATUS_CHANGED: ' + s.id);
                if (this.session.id === s.id) {
                    this.messageService.getSession(this.session.id).subscribe((res1) => {
                        this.onSuccess(res1.body);
                    });
                    // this.open(this.sessionEndedModal);
                }
            }
            else if (type === 'SESSION_LANGUAGE_UPDATED') {
                let s = message;
                if (this.session.id === s.id) {
                    this.messageService.getSession(this.session.id).subscribe((res1) => {
                        this.session = res1.body;
                    });
                }
            }
            else if (type === 'VIDEO_CALL_TRANSCRIPTION_STATUS_UPDATED') {
                let transcriptionEnabled = message;
                this.isTranscriptionEnabled = transcriptionEnabled;
            }
        });
    }
    joinVideoCall() {
        this.view = 'JOINED';
        const userLogin = this.accountService.getCurrentLoggedInUser().login;
        this.videoCallService.joinVideoCall(this.session).subscribe(videoCallJoinInfo => {
            this.isTranscriptionEnabled = videoCallJoinInfo.body.transcriptionEnabled;
            this.zoomService.joinVideoCall(userLogin, videoCallJoinInfo.body).subscribe(() => {
                this.onJoinedToVideoCall();
            });
        }, error => {
            this.redirectToSessionChat();
        });
    }
    onJoinedToVideoCall() {
        if (!this.onVideoCallEndedSubscription) {
            this.onVideoCallEndedSubscription = this.zoomService.onVideoCallEnded$().subscribe(() => {
                this.redirectToSessionChat();
            });
        }
    }
    onSuccess(body) {
        this.session = body;
        if (this.session.ended) {
            this.redirectToSessionChat();
            return;
        }
        this.coach = this.session.coach;
        this.srqCompletedService.srqHistoryByUser(this.session.user.id).subscribe((res) => {
            this.srqHistory = res.body;
        });
        // this.updateMinutesLeftRecurring(2);
    }
    onError(err) {
        console.log('error occured: ' + JSON.stringify(err.status));
        if (err.status === 404) {
            // this.modalService.open(this.sessionDoesNotExistModal);
        }
    }
    endVideoCall() {
        this.videoCallService.endVideoCall(this.session).subscribe(() => {
            this.zoomService.endVideoCall().subscribe(() => {
            });
        });
    }
    redirectToSessionChat() {
        this.router.navigate(['/session/chat-coach', this.session.id]).then();
    }
    switchViewMode(newMode) {
        if (newMode === 'UserInfo' && !this.userAllSessions) {
            this.toggleUserJourney();
        }
        this.viewMode = newMode;
        if (this.viewMode === 'Chat' || this.viewMode === 'Transcript') {
            this.updateChatUiComponentSize();
        }
    }
    updateChatUiComponentSize() {
        this.eventManager.broadcast('update-chat-ui-component-size');
    }
    toggleUserJourney() {
        this.showUserJourney = !this.showUserJourney;
        if (this.showUserJourney && !this.userAllSessions) {
            this.loadAllSessions();
        }
    }
    showPreviousSessionTranscriptInThisTab(session) {
        this.previousSessionToShowTranscript = session;
        this.ngbModalRef = this.modalService.open(this.previousSessionTranscriptModal, { size: 'xl' });
    }
    showPreviousSessionTranscriptInNewTab(session) {
        // this.router.navigate(['/past',session.id]);
        this.router.navigate([]).then(result => { window.open('/#/past/' + session.id, '_blank'); });
    }
    loadAllSessions() {
        this.sessionService.getSessionsByUserId(this.session.user.id).subscribe((sessions) => {
            this.userAllSessions = sessions.body;
        });
    }
    toggleRightSidebar() {
        this.showRightSidebar = !this.showRightSidebar;
        if (this.showRightSidebar) {
            this.updateChatUiComponentSize();
        }
    }
    toggleScriptSelector() {
        this.showScriptSelector = !this.showScriptSelector;
    }
    goToLink(link) {
        window.open(link, '_blank');
    }
    onResourceSelected($event) {
        this.message = '';
        setTimeout(() => {
            this.message = $event.resource;
        }, 0);
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
            this.closeResult = `Closed with: ${result}`;
        }, reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    onScriptSelected($event) {
        // console.log('onScriptSelected:' + $event.script);
        this.message = '';
        setTimeout(() => {
            // console.log("setTimeout 2: " + $event.script);
            this.message = $event.script;
        }, 0);
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.showRightSidebar = this.isScreenLg;
    }
    ngOnDestroy() {
        var _a, _b, _c;
        (_a = this.onVideoCallEndedSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.organizationResourceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.websocketSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        this.zoomService.destroy();
    }
    updateUnreadMessageCount(count) {
        this.unreadMessageCount = count;
        this.updateUnreadIndicator();
    }
    updateUnreadIndicator() {
        if (!this.showRightSidebar && this.unreadMessageCount > 0) {
            this.showUnreadIndicator = true;
        }
        else {
            this.showUnreadIndicator = false;
        }
    }
    turnOffTranscription() {
        this.videoCallService.updateTranscriptionStatus(this.session.id, false).subscribe(value => {
            this.zoomService.turnOffTranscription();
        });
    }
    turnOnTranscription() {
        this.videoCallService.updateTranscriptionStatus(this.session.id, true).subscribe(value => {
            this.zoomService.turnOnTranscription();
        });
    }
}
VideoSessionCoachComponent.ɵfac = function VideoSessionCoachComponent_Factory(t) { return new (t || VideoSessionCoachComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SRQCompletedService), i0.ɵɵdirectiveInject(i4.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i6.SessionStorageService), i0.ɵɵdirectiveInject(i7.TrackerService), i0.ɵɵdirectiveInject(i8.NgbModal), i0.ɵɵdirectiveInject(i9.JhiAlertService), i0.ɵɵdirectiveInject(i10.TranslateService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i9.JhiEventManager), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i11.VideoCallService), i0.ɵɵdirectiveInject(i12.ZoomService), i0.ɵɵdirectiveInject(i13.AccountService)); };
VideoSessionCoachComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoSessionCoachComponent, selectors: [["video-session-coach"]], viewQuery: function VideoSessionCoachComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previousSessionTranscriptModal = _t.first);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["class", "olha-theme", 4, "ngIf"], ["previousSessionTranscriptModal", ""], [1, "olha-theme"], [1, "coach-session-video-container", "d-flex", "flex-column", "justify-content-center"], ["coachSessionVideoContainer", ""], [4, "ngIf"], [1, "video-call-preview-container", "d-flex", "justify-content-center", "flex-grow-1"], ["isLanguageChangeable", "true", 3, "session", "onJoinCallClick"], ["headerContainer", ""], [1, "d-none", "d-lg-flex"], [2, "width", "100%", 3, "session", "isUserPanelOn", "showUnreadIndicator", "isScriptOn", "displayScriptComponent", "displayUserPanel", "onStopCall", "resourceSelected"], [1, "d-flex", "d-lg-none"], [2, "width", "100%", 3, "session", "showUnreadIndicator", "isUserPanelOn", "isScriptOn", "displayScriptComponent", "displayUserPanel", "resourceSelected"], [1, "main-container", "flex-grow-1", "d-lg-flex", 3, "ngStyle"], ["mainContainer", ""], [1, "script-sidebar", 3, "ngClass"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "h-100"], [1, "d-flex", "flex-grow-1", 3, "messageSelected"], [1, "zoom-call-container", 3, "ngClass", "ngStyle"], ["zoomCallContainer", ""], [2, "width", "100%", 3, "session", "height", "participantUser", "selfUser"], [1, "right-sidebar", 3, "ngClass", "ngStyle"], ["rightSidebarContainer", ""], [1, "row", "m-0"], [1, "col", "p-0"], [3, "session", "user", "srqHistory", "showCloseIcon", "onCloseIconClick", 4, "ngIf"], [1, "my-0", "mx-4", 2, "border-top", "1px solid #DFF1EC"], [1, "row", "m-0", "px-2", "pt-3", "pb-3", "justify-content-around"], [1, "col"], ["jhiTranslate", "inukaNgApp.inukaJourney.journey", 1, "text-success", "h4", 3, "click"], [1, "col", "text-right"], [3, "click"], [1, "angle-icon", 2, "height", "22px", "width", "22px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down", 4, "ngIf"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up", 4, "ngIf"], ["class", "row m-0", "style", "height: 60%;", 4, "ngIf"], [1, "row", "m-0", "text-center"], [1, "col", "px-2", "py-3", "pointer", "border", "border-primary", "border-left-0", "border-right-0", "rounded-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.chat", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [1, "col", "px-2", "py-3", "pointer", "border", "border-primary", "border-right-0", "rounded-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.transcript", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], ["jhiTranslate", "sessionChat.button.actionPlan", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], ["jhiTranslate", "sessionChat.button.notes", 1, "mb-0", "w-100", "text-center", "font-weight-bold"], [1, "view-mode-parent", "flex-grow-1", 3, "ngClass"], ["chatContainer", ""], [1, "chat-container-coach", "p-1", "flex-grow-1", 3, "ngStyle"], ["style", "height: 100%", 3, "viewportHeight", "session", "displayingPastSession", "unreadMessageCountChange", "repliedMessage", 4, "ngIf"], ["messageSendContainer", ""], [3, "session", "message", "maxCharacterSize", "messageToBeReplied"], ["transcriptContainer", ""], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", 3, "viewportHeight", "session", "displayingPastSession", 4, "ngIf"], [1, "transcription-status", "text-center", "py-3"], ["transcriptionStatusContainer", ""], ["class", "btn btn-link", "jhiTranslate", "sessionChat.coachSessionControl.turnOffTranscription", 3, "click", 4, "ngIf"], ["class", "btn btn-link", "jhiTranslate", "sessionChat.coachSessionControl.turnOnTranscription", 3, "click", 4, "ngIf"], ["class", "p-1", "style", "position: relative; flex: 1 1 0;", 4, "ngIf"], [1, "d-block", "d-lg-none"], ["footerContainer", ""], [3, "session", "onStopCall"], [3, "session", "user", "srqHistory", "showCloseIcon", "onCloseIconClick"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up"], [1, "row", "m-0", 2, "height", "60%"], [2, "position", "relative", "flex", "1 1 0", "height", "100%"], [2, "position", "absolute", "right", "0", "left", "0", "display", "flex", "flex-direction", "column", "height", "95%"], [1, "flex-grow-1", "py-0", 2, "overflow-y", "scroll", "overflow-x", "hidden", "height", "100%"], [3, "sessions", "srqHistory", "sessionSelectedToOpenInThisTab", "sessionSelectedToOpenInNewTab"], [2, "height", "100%", 3, "viewportHeight", "session", "displayingPastSession", "unreadMessageCountChange", "repliedMessage"], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", 3, "viewportHeight", "session", "displayingPastSession"], ["jhiTranslate", "sessionChat.coachSessionControl.turnOffTranscription", 1, "btn", "btn-link", 3, "click"], ["jhiTranslate", "sessionChat.coachSessionControl.turnOnTranscription", 1, "btn", "btn-link", 3, "click"], [1, "p-1", 2, "position", "relative", "flex", "1 1 0"], [2, "position", "absolute", "right", "0", "left", "0", "display", "flex", "flex-direction", "column", "height", "100%"], [1, "flex-grow-1", "py-3", 2, "overflow-y", "scroll", "overflow-x", "hidden"], [3, "session", "disabled"], [1, "flex-grow-1", "py-3", "pr-3", "pl-3", 2, "overflow", "hidden"], [1, "d-flex", "align-items-center", "justify-content-end", "pr-4"], ["id", "user-home-expand-chat-btn", 1, "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "expand", 2, "width", "1.2rem!important", "height", "1.2rem!important"], [0, "xlink", "href", "../../../../../../../../../../../../content/images/sprite.svg?v=3#expand"], [3, "isEmbedded", "userId", "coachId"], [1, "modal-body", 2, "height", "830px"], [3, "showInModal", "session"]], template: function VideoSessionCoachComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VideoSessionCoachComponent_div_0_Template, 5, 2, "div", 0);
        i0.ɵɵtemplate(1, VideoSessionCoachComponent_ng_template_1_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.session);
    } }, directives: [i14.NgIf, i15.JoinVideoCallComponent, i16.CoachSessionControlComponent, i17.CoachSessionControlUpperMobileComponent, i14.NgStyle, i14.NgClass, i18.FaIconComponent, i19.ScriptsComponent, i20.ZoomCallComponent, i21.JhiTranslateDirective, i22.SessionMessageSendComponent, i23.CoachSessionControlLowerMobileComponent, i24.UserInfoComponent, i25.InukaJourneyCoachChatComponent, i26.ChatUiNewComponent, i27.EditActionPlanComponent, i28.MatTooltip, i29.CoachUserNoteComponent, i30.PreviousSessionTranscriptPopupComponent], pipes: [i10.TranslatePipe], styles: [".coach-session-video-container[_ngcontent-%COMP%]{height:100vh;padding-top:60px;overflow:hidden}.video-call-preview-container[_ngcontent-%COMP%]{background-color:#0a4a3a}.zoom-call-container[_ngcontent-%COMP%]{overflow:hidden;flex-grow:1;height:100%}.zoom-call-container[_ngcontent-%COMP%]   *[_ngcontent-%COMP%] > {width:100%}.main-container[_ngcontent-%COMP%]{position:relative}.right-sidebar[_ngcontent-%COMP%]{z-index:1;background-color:#fff;overflow:hidden;height:100%}.view-mode-button[_ngcontent-%COMP%]{border:1px solid}.viewModeButtonActive[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:#fff}.script-sidebar[_ngcontent-%COMP%]{position:absolute;left:0;top:0;z-index:1;height:100%;width:100%;background-color:#fff}.transcription-status[_ngcontent-%COMP%]{background-color:var(--bg-1)}@media(min-width: 1200px){.script-sidebar[_ngcontent-%COMP%]{width:20%}.coach-session-video-container[_ngcontent-%COMP%]{padding-top:60px}.right-sidebar[_ngcontent-%COMP%]{width:25%}}"] });
